import React from 'react';
import Image from 'next/image';

const PricingItem = ({ imgSrc, pricePerAnnotation, pricePerImage, title }) => (
  <li className="items-center p-4 border-b border-gray-800 md:flex">
    <div className="flex items-center md:w-2/5">
      <Image width={32} height={32} src={imgSrc} />
      <span className="ml-4 ">{title}</span>
    </div>
    <div className="ml-12 sm:ml-0 md:w-1/3">{pricePerImage}</div>
    <div className="ml-12 sm:ml-0">{pricePerAnnotation}</div>
  </li>
);

export default PricingItem;
